module.exports = __webpack_public_path__ + "media/steps/scroll-down-background-bb54479d.png";